export default __webpack_public_path__ + "static/media/jess-snoek-rDud6SN-ZVo-unsplash.c34bc10c.jpg";